module.exports = __webpack_public_path__ + "static/media/pdf.0afda794.svg";